import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CustomIcon } from '@components/shared';
import { RawToggle } from '@components/shared/forms';
import { SavedSearch } from '@root/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ListingSearchCriteria as ListingSearchCriteriaDeprecated } from '@components/layouts/Truva/ListingSearchDeprecated/utils';
import ListingSearchCriteria from '@components/layouts/Truva/ListingSearch/utils/Criteria/ListingSearchCriteria';
import s from './Searches.module.less';

type Props = {
  search: SavedSearch;
  onDeleteClick: (s: SavedSearch) => void;
  goToSavedSearch: () => void;
  toggleNotification: (id: string, receivesNotifications: boolean) => Promise<void>;
};

const SearchRow = ({ search, onDeleteClick, goToSavedSearch, toggleNotification }: Props) => {
  const flags = useFlags();
  let criteria;

  if (flags['search-redesign']) {
    criteria = ListingSearchCriteria.fromSavedSearch(search.criteria);
  } else {
    criteria = new ListingSearchCriteriaDeprecated(search.criteria);
  }

  const { t } = useTranslation('favorites');

  return (
    <li className={s.search}>
      <div className={s.name}>
        <Link onClick={goToSavedSearch} to={criteria.toUrl()}>
          {flags['save-search-redesign'] && search.name ? search.name : search.description}
        </Link>
        {flags['save-search-redesign'] ? <p>{search.description}</p> : null}
      </div>
      <div className={s.alerts}>
        <div>
          <span className={s.alertLabel}>{t('emailAlerts')}</span>
          <RawToggle
            onChange={receivesNotifications => toggleNotification(search.id, receivesNotifications)}
            name={`${search.id}-alerts`}
            checked={search.receivesNotifications}
          />
          <span className={s.alertAside}>{t(search.receivesNotifications ? 'on' : 'off')}</span>
        </div>
      </div>
      <div className={s.controls}>
        <button
          data-testid={`delete-search-${search.id}`}
          type="button"
          onClick={() => onDeleteClick(search)}
          className={s.deleteButton}
        >
          <CustomIcon type="trash" />
        </button>
      </div>
    </li>
  );
};

export default SearchRow;
